import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  NitroDataGrid,
  NitroHeading,
  NitroIcon,
  NitroLoading,
  NitroPanel,
} from 'nitro-components';
import DisableCover from '@src/components/libs/disabled';

import { connect } from 'react-redux';
import AdminAPI from '../../../api/AdminApi';

import AddNewRoles from './roles/AddNewRoles';

const ContainerDiv = styled.div`
  width: 100% !important;
  margin-left: 0px;
  margin-right: 20px;
`;
const Container = styled.div``;

const Text = styled.span`
  display: inline-block;
  text-transform: lowercase;
  &:first-letter {
    text-transform: uppercase;
  }
`;

const TransformText = ({ data }) => <Text>{data}</Text>;

class UserRole extends Component {
  static propTypes = {
    allRoles: PropTypes.arrayOf(PropTypes.object).isRequired,
    action: PropTypes.func.isRequired,
    userid: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      userRoles: [],
      isLoading: false,
    };
  }

  componentWillMount() {
    if (this.props.userid && this.props.userid !== 'new') {
      this.getUserRoles(this.props.userid);
    }
  }

  syncChanges = () => {
    const { userRoles } = this.state;
    this.props.action(userRoles);
  };

  onDeleteClicked = (data, e) => {
    e.stopPropagation();

    const { userRoles } = this.state;
    const newUserRoles = userRoles.filter(ea => ea.id !== data.id);

    this.setState(
      {
        userRoles: newUserRoles,
      },
      () => this.syncChanges()
    );
  };

  getColumnMetaDataRoles() {
    this.rolesColumnMeta = [
      {
        columnName: 'name',
        displayName: 'Role',
        sortable: true,
        customComponent: TransformText,
      },
      {
        columnName: 'description',
        displayName: 'Description',
        customComponent: TransformText,
        sortable: false,
      },
      {
        columnName: 'Delete',
        displayName: ' ',
        sortable: false,
        width: '100',
        customComponent: ({ data, rowData }) => (
          <span
            className="griddle-action"
            style={{
              display: this.props.allRoles.length > 0 ? 'block' : 'none',
            }}
          >
            <NitroIcon
              name="delete"
              variant="secondary"
              size={16}
              alignment
              clickable
              action={e => {
                this.onDeleteClicked(rowData, e);
              }}
            />
          </span>
        ),
      },
    ];
    return this.rolesColumnMeta;
  }

  setLoading = status => {
    this.setState({
      isLoading: status,
    });
  };

  getUserRoles = userid => {
    this.setLoading(true);
    AdminAPI.getUserRoles(userid).then(response => {
      this.setState(
        {
          isLoading: false,
          userRoles: response,
        },
        () => this.syncChanges()
      );
    });
  };

  handleRoleSelection = role => {
    const tempRoles = [...this.state.userRoles, role];
    this.setState(
      {
        userRoles: tempRoles,
      },
      () => this.syncChanges()
    );
  };

  render() {
    const { isLoading } = this.state;

    return (
      <NitroPanel>
        {isLoading && (
          <div>
            <DisableCover />
            <NitroLoading center screen />
          </div>
        )}
        <Container>
          <NitroHeading label="User Roles" size="1" variant="secondary" />
        </Container>
        <ContainerDiv>
          {this.state.userRoles.length > 0 && (
            <NitroDataGrid
              results={this.state.userRoles}
              columnMetaData={this.getColumnMetaDataRoles()}
              sortColumnAscendingCls="sort-column-ascending"
              sortColumnDescendingCls="sort-column-descending"
            />
          )}
        </ContainerDiv>
        {this.props.allRoles && this.props.allRoles.length > 0 && (
          <ContainerDiv>
            <AddNewRoles
              action={this.handleRoleSelection}
              allRoles={this.props.allRoles}
            />
          </ContainerDiv>
        )}
      </NitroPanel>
    );
  }
}

export default connect(
  null,
  null,
  null,
  { withRef: true }
)(UserRole);



// WEBPACK FOOTER //
// ./src/features/admin/components/UserRole.js